import { useContext } from "react";
import ApartmentIcon from '@mui/icons-material/Apartment';
import { FilterContext } from "../../contexts/FilterContext";
import { Badge, Box, Tooltip } from "@mui/material";

export const columnsReport = [
	{
		field: "CNPJ",
		headerName: "CNPJ/CPF Cliente/Devedor",
		width: 175,
		headerAlign: "center",
		align: "left",
		valueFormatter: ({ value }) => {
			if (value.length > 11) {
				return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
			} else {

				return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			}
		}
	},
	{
		field: "devedor",
		headerName: "Cliente/Devedor",
		width: 470,
		headerAlign: "center",
		align: "left",
	},
	{
		field: "contrato",
		headerName: "Contrato",
		width: 95,
		headerAlign: "center",
		align: "center",
	},
	{
		field: "id_estagio",
		headerName: "Estágio",
		width: 110,
		headerAlign: "center",
		align: "left",
	},
	{
		field: "motivo",
		headerName: "Motivo",
		width: 200,
		headerAlign: "center",
		align: "left",
	},
	{
		field: "data_entrada",
		headerName: "Entrada",
		width: 125,
		headerAlign: "center",
		align: "center",
		valueFormatter: ({ value }) =>
			{
				return value ? new Date(value).toLocaleDateString("pt-Br") : ""},
	},
	{
		field: "titulo",
		headerName: "Título",
		width: 120,
		headerAlign: "center",
		align: "center",
	},
	{
		field: "vencimento",
		headerName: "Vencimento",
		width: 125,
		headerAlign: "center",
		align: "center",
		valueFormatter: ({ value }) =>
			value ? new Date(value).toLocaleDateString("pt-Br") : "",
	},
	{
		field: "valor_original",
		headerName: "Valor Original",
		width: 150,
		headerAlign: "center",
		align: "right",
		valueFormatter: ({ value }) =>
			"R$ " + parseFloat(value).toLocaleString("pt-Br", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
	},
	{
		field: "saldo",
		headerName: "Saldo",
		width: 150,
		headerAlign: "center",
		align: "right",
		valueFormatter: ({ value }) =>
			"R$ " + parseFloat(value).toLocaleString("pt-Br", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
	},
	{
		field: "data_acordo",
		headerName: "Acordo",
		width: 125,
		headerAlign: "center",
		align: "right",
		valueFormatter: ({ value }) =>
			value ? new Date(value).toLocaleDateString("pt-Br") : "",
	},
	{
		field: "id_acordo",
		headerName: "ID do acordo",
		width: 100,
		headerAlign: "center",
		align: "right",
	},
	{
		field: "data_finalizacao",
		headerName: "Finalização",
		headerAlign: "center",
		width: 125,
		align: "center",
		valueFormatter: ({ value }) =>
			value ? new Date(value).toLocaleDateString("pt-Br") : "",
	},
];


export function useColumnsModal() {

	const { groupsSelected } = useContext(FilterContext)

	const visibleLegend = groupsSelected.length > 1

	const columns = [
		{
			field: "credor_id",
			headerName: "Credor",
			width: 100,
			headerAlign: "center",
			align: "left",
			renderCell: (params) => {
				const index = (groupsSelected?.findIndex(el => el.id === params.value) + 1)
				const title = groupsSelected?.find(el => el.id === params.value)?.label
				return (
					<Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
						<Tooltip PopperProps={{
							sx: {
								textTransform: "capitalize"
							}
						}} title={title}>
							<span>{index}</span>
						</Tooltip>
					</Box>
				)
			}
		},
		...columnsReport,
	]

	if (!visibleLegend) {
		columns.splice(0, 1);
	}

	return {
		visibleLegend,
		columns
	}
}